export default "__VITE_ASSET__BmU9yu7e__"